import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";
import { FormGroup } from "../../../../components/Form/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

export const Container = styled.div`
  padding-bottom: 2rem;
`;

/* A titled block of the screen: small uppercase label + card (same as /settings) */
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

/* The integration itself: logo, name, whether it is set up, and where to find the ID */
export const Intro = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  .top {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  img {
    flex-shrink: 0;
    border-radius: 12px;
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .status {
    display: inline-flex;
    gap: 0.375rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1rem;
    color: ${props => (props.$active ? "var(--color-feedback-success)" : "var(--color-neutral-150)")};

    &::before {
      width: 6px;
      height: 6px;
      content: "";
      background-color: currentColor;
      border-radius: 100%;
    }
  }

  p {
    font-size: 0.8125rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  /* The card's gap already spaces the fields */
  ${FormGroup} {
    margin-bottom: 0;
  }
`;

/* Discard/save for the fields above, right-aligned at the bottom of the card */
export const CardFooter = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid var(--color-neutral-base);
`;

export const RemoveLink = styled.button`
  align-self: flex-start;
  margin: 2rem 2rem 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-feedback-danger);

  &:hover {
    text-decoration: underline;
  }

  @media ${MOBILE} {
    margin: 1.5rem 20px 0;
  }
`;
